var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApptensionLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_18382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8093 18.7089L17.9649 14.9432L19.7468 13.1978L21.8093 15.2182L25.3119 11.7872L16 2.65392L1.91609 16.4495L11.2281 25.5828L14.7429 22.1518L12.6804 20.1315L14.4622 18.3862L18.3066 22.1518L13.0221 27.3282L16.0122 30.257L30.0961 16.4615L27.106 13.5326L21.8093 18.7089ZM9.69035 17.1907L8.40884 15.9354L15.4752 9.01376L16.7567 10.257L9.69035 17.1907ZM27.2281 11.0101L16 0L0 15.6725V24.3276L11.0938 35.1943V35.2062L16 40L32 24.3276V15.6725L27.2281 11.0101ZM31.2067 23.9929L16 38.8882L11.8871 34.8715V33.5685L11.2281 34.214L0.793287 23.9929V15.9952L16 1.09982L26.4348 11.321V12.6241L27.0938 11.9785L31.2067 15.9952V23.9929Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_18382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApptensionLogo);
export default __webpack_public_path__ + "static/media/apptension-logo.ab26fb4a798b0b8fbfe807183206aea6.svg";
export { ForwardRef as ReactComponent };